import type { BusinessAuthMessage, BusinessAuthNextStep } from '@/features/auth/authTypes';

export const PasswordResetErrorCode = {
  InvalidRequest: 'InvalidRequest',
  InvalidResetCode: 'InvalidOrExpiredVerificationCode',
  InvalidPassword: 'InvalidPassword',
  RateLimited: 'RateLimited',
  InternalError: 'InternalError',
} as const;

export type PasswordResetErrorCode = (typeof PasswordResetErrorCode)[keyof typeof PasswordResetErrorCode];

export interface ForgotPasswordRequest {
  email: string;
}

export interface ConfirmForgotPasswordRequest {
  email: string;
  code: string;
  newPassword: string;
}

export interface PasswordResetResponse {
  success: boolean;
  message: BusinessAuthMessage | string;
  data?: { nextStep: BusinessAuthNextStep } | null;
  retryAfterSeconds?: number;
}

export interface PasswordResetState {
  step: 'request' | 'confirm';
  email: string | null;
  isRequesting: boolean;
  isConfirming: boolean;
  error: string | null;
  errorCode: PasswordResetErrorCode | null;
}
